<template>
  <div>
    <div
      class="content flex justify-between items-center"
      style="height: 104px"
    >
      <div class="flex items-center">
        <router-link to="/" class="flex items-center">
          <img class="h-16" :src="platform.logo" alt="" />
          <span class="ml-2 text-3xl font-bold">{{ platform.title }}</span>
        </router-link>
      </div>

      <router-link
        class="text-base font-bold text-primary py-3 px-5 border border-primary"
        to="/"
        >返回官网</router-link
      >
    </div>

    <slot></slot>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AuthLayout",
  components: {},
  computed: {
    ...mapState("app", ["platform"]),
  },
};
</script>

<style lang="scss" scoped></style>
